import type { Template, ColorPalette, Typography, TemplatePalette } from '@/types/templates'

// Per-template palettes organized by template slug
export const TEMPLATE_PALETTES: Record<string, TemplatePalette[]> = {
  'beauty': [
    {
      id: 'beauty-rose',
      name: 'Rose Glamour',
      isPrimary: true,
      colors: {
        primary: '#9d174d',
        secondary: '#fdf2f8',
        accent: '#d4af37',
        background: '#fdf2f8',
        text: '#831843',
        textMuted: '#9d174d',
      },
    },
    {
      id: 'beauty-gold',
      name: 'Gold Luxe',
      isPrimary: false,
      colors: {
        primary: '#D4AF37',
        secondary: '#1A1A1A',
        accent: '#F7E7CE',
        background: '#FAF7F2',
        text: '#0A0A0A',
        textMuted: '#2D2D2D',
      },
    },
  ],
  'photographer': [
    {
      id: 'photographer-dark',
      name: 'Dark Elegance',
      isPrimary: true,
      colors: {
        primary: '#ffffff',
        secondary: '#2d3436',
        accent: '#00cec9',
        background: '#1a1a1a',
        text: '#ffffff',
        textMuted: '#b2bec3',
      },
    },
    {
      id: 'photographer-light',
      name: 'Light Studio',
      isPrimary: false,
      colors: {
        primary: '#000000',
        secondary: '#f5f5f5',
        accent: '#0066CC',
        background: '#FFFFFF',
        text: '#1a1a1a',
        textMuted: '#666666',
      },
    },
    {
      id: 'photographer-warm',
      name: 'Warm Tone',
      isPrimary: false,
      colors: {
        primary: '#2d3436',
        secondary: '#ffeaa7',
        accent: '#e17055',
        background: '#fdf6e3',
        text: '#2d3436',
        textMuted: '#636e72',
      },
    },
  ],
  'creative': [
    {
      id: 'creative-portfolio',
      name: 'Creative Portfolio',
      isPrimary: true,
      colors: {
        primary: '#1a1a2e',
        secondary: '#16213e',
        accent: '#e94560',
        background: '#fafafa',
        text: '#1a1a2e',
        textMuted: '#6c757d',
      },
    },
    {
      id: 'artisan-studio',
      name: 'Artisan Studio',
      isPrimary: false,
      colors: {
        primary: '#2d3436',
        secondary: '#636e72',
        accent: '#fdcb6e',
        background: '#ffffff',
        text: '#2d3436',
        textMuted: '#636e72',
      },
    },
  ],
  'trade': [
    {
      id: 'trade-professional',
      name: 'Trade Professional',
      isPrimary: true,
      colors: {
        primary: '#1E3A5F',
        secondary: '#4A6FA5',
        accent: '#FF6B35',
        background: '#F8F9FA',
        text: '#333333',
        textMuted: '#666666',
      },
    },
    {
      id: 'handyman-blue',
      name: 'Handyman Blue',
      isPrimary: false,
      colors: {
        primary: '#0077b6',
        secondary: '#00b4d8',
        accent: '#ff6b35',
        background: '#ffffff',
        text: '#333333',
        textMuted: '#666666',
      },
    },
    {
      id: 'construction-orange',
      name: 'Construction Orange',
      isPrimary: false,
      colors: {
        primary: '#2c3e50',
        secondary: '#e67e22',
        accent: '#f39c12',
        background: '#ffffff',
        text: '#2c3e50',
        textMuted: '#7f8c8d',
      },
    },
  ],
  'universal': [
    {
      id: 'modern-minimal',
      name: 'Modern Minimal',
      isPrimary: true,
      colors: {
        primary: '#333333',
        secondary: '#FFFFFF',
        accent: '#FFB6C1',
        background: '#FFFFFF',
        text: '#333333',
        textMuted: '#666666',
      },
    },
  ],
  'services': [
    {
      id: 'service-green',
      name: 'Service Green',
      isPrimary: true,
      colors: {
        primary: '#27ae60',
        secondary: '#2ecc71',
        accent: '#f39c12',
        background: '#ffffff',
        text: '#333333',
        textMuted: '#666666',
      },
    },
    {
      id: 'professional-builder',
      name: 'Professional Builder',
      isPrimary: false,
      colors: {
        primary: '#1E3A5F',
        secondary: '#4A6FA5',
        accent: '#FF6B35',
        background: '#FFFFFF',
        text: '#333333',
        textMuted: '#666666',
      },
    },
  ],
  'artistic': [
    {
      id: 'gallery-white',
      name: 'Gallery White',
      isPrimary: true,
      colors: {
        primary: '#000000',
        secondary: '#FFFFFF',
        accent: '#0066CC',
        background: '#FFFFFF',
        text: '#000000',
        textMuted: '#666666',
      },
    },
    {
      id: 'photo-dark',
      name: 'Photography Dark',
      isPrimary: false,
      colors: {
        primary: '#ffffff',
        secondary: '#2d3436',
        accent: '#00cec9',
        background: '#1a1a1a',
        text: '#ffffff',
        textMuted: '#b2bec3',
      },
    },
  ],
  // Individual template slugs (specific templates)
  'tattoo-artist': [
    {
      id: 'tattoo-edgy',
      name: 'Tattoo Edgy',
      isPrimary: true,
      colors: {
        primary: '#1A1A1A',
        secondary: '#FF00FF',
        accent: '#00FFFF',
        background: '#1A1A1A',
        text: '#F5F0E8',
        textMuted: '#C0C0C0',
      },
    },
    {
      id: 'creative-portfolio',
      name: 'Creative Portfolio',
      isPrimary: false,
      colors: {
        primary: '#1a1a2e',
        secondary: '#16213e',
        accent: '#e94560',
        background: '#fafafa',
        text: '#1a1a2e',
        textMuted: '#6c757d',
      },
    },
  ],
  'florist': [
    {
      id: 'florist-natural',
      name: 'Florist Natural',
      isPrimary: true,
      colors: {
        primary: '#2D4A3E',
        secondary: '#9CAF88',
        accent: '#D4A5A5',
        background: '#FDF8F5',
        text: '#2D4A3E',
        textMuted: '#9CAF88',
      },
    },
    {
      id: 'artisan-studio',
      name: 'Artisan Studio',
      isPrimary: false,
      colors: {
        primary: '#2d3436',
        secondary: '#636e72',
        accent: '#fdcb6e',
        background: '#ffffff',
        text: '#2d3436',
        textMuted: '#636e72',
      },
    },
  ],
  'artist-painter': [
    {
      id: 'gallery-white',
      name: 'Gallery White',
      isPrimary: true,
      colors: {
        primary: '#000000',
        secondary: '#FFFFFF',
        accent: '#0066CC',
        background: '#FFFFFF',
        text: '#000000',
        textMuted: '#666666',
      },
    },
    {
      id: 'artist-contemporary',
      name: 'Artist Contemporary',
      isPrimary: false,
      colors: {
        primary: '#0F0F0F',
        secondary: '#FF6B6B',
        accent: '#4ECDC4',
        background: '#F5F5F0',
        text: '#333333',
        textMuted: '#333333',
      },
    },
  ],
  'makeup-artist': [
    {
      id: 'bold-beauty',
      name: 'Bold Beauty',
      isPrimary: true,
      colors: {
        primary: '#FF69B4',
        secondary: '#000000',
        accent: '#FFD700',
        background: '#FFFFFF',
        text: '#000000',
        textMuted: '#333333',
      },
    },
    {
      id: 'beauty-luxurious',
      name: 'Beauty Luxurious',
      isPrimary: false,
      colors: {
        primary: '#D4AF37',
        secondary: '#CD7F32',
        accent: '#2D2D2D',
        background: '#FAF7F2',
        text: '#0A0A0A',
        textMuted: '#2D2D2D',
      },
    },
  ],
  'nail-technician': [
    {
      id: 'nail-feminine',
      name: 'Nail Technician Feminine',
      isPrimary: true,
      colors: {
        primary: '#DB2777',
        secondary: '#F472B6',
        accent: '#059669',
        background: '#FDF2F8',
        text: '#831843',
        textMuted: '#9D174D',
      },
    },
    {
      id: 'serene-spa',
      name: 'Serene Spa',
      isPrimary: false,
      colors: {
        primary: '#9CAF88',
        secondary: '#F5F5DC',
        accent: '#D4AF37',
        background: '#FFFAF0',
        text: '#333333',
        textMuted: '#666666',
      },
    },
  ],
  'hair-stylist': [
    {
      id: 'hair-editorial',
      name: 'Hair Stylist Editorial',
      isPrimary: true,
      colors: {
        primary: '#1C1917',
        secondary: '#78716C',
        accent: '#D97706',
        background: '#FAFAF9',
        text: '#1C1917',
        textMuted: '#44403C',
      },
    },
    {
      id: 'natural-luxe',
      name: 'Natural Luxe',
      isPrimary: false,
      colors: {
        primary: '#C67B5C',
        secondary: '#D4B896',
        accent: '#556B2F',
        background: '#FAF0E6',
        text: '#333333',
        textMuted: '#666666',
      },
    },
  ],
  'esthetician': [
    {
      id: 'esthetician-spa',
      name: 'Esthetician Spa',
      isPrimary: true,
      colors: {
        primary: '#F43F5E',
        secondary: '#FDA4AF',
        accent: '#6B7280',
        background: '#FFF1F2',
        text: '#1F2937',
        textMuted: '#6B7280',
      },
    },
    {
      id: 'serene-spa',
      name: 'Serene Spa',
      isPrimary: false,
      colors: {
        primary: '#9CAF88',
        secondary: '#F5F5DC',
        accent: '#D4AF37',
        background: '#FFFAF0',
        text: '#333333',
        textMuted: '#666666',
      },
    },
  ],
  'event-planner': [
    {
      id: 'event-planner-elegant',
      name: 'Event Planner Elegant',
      isPrimary: true,
      colors: {
        primary: '#1A1A1A',
        secondary: '#F7E7CE',
        accent: '#D4AF37',
        background: '#FFFFF0',
        text: '#1A1A1A',
        textMuted: '#E8B4B8',
      },
    },
    {
      id: 'artisan-studio',
      name: 'Artisan Studio',
      isPrimary: false,
      colors: {
        primary: '#2d3436',
        secondary: '#636e72',
        accent: '#fdcb6e',
        background: '#ffffff',
        text: '#2d3436',
        textMuted: '#636e72',
      },
    },
  ],
  'tutor-teacher': [
    {
      id: 'tutor-academic',
      name: 'Tutor Academic',
      isPrimary: true,
      colors: {
        primary: '#1A365D',
        secondary: '#2C5282',
        accent: '#D69E2E',
        background: '#EBF8FF',
        text: '#4A5568',
        textMuted: '#4A5568',
      },
    },
    {
      id: 'modern-minimal',
      name: 'Modern Minimal',
      isPrimary: false,
      colors: {
        primary: '#333333',
        secondary: '#FFFFFF',
        accent: '#FFB6C1',
        background: '#FFFFFF',
        text: '#333333',
        textMuted: '#666666',
      },
    },
  ],
  'personal-trainer': [
    {
      id: 'trainer-energetic',
      name: 'Personal Trainer Energetic',
      isPrimary: true,
      colors: {
        primary: '#FF4500',
        secondary: '#FF6B35',
        accent: '#1E1E1E',
        background: '#DFE6E9',
        text: '#2D3436',
        textMuted: '#2D3436',
      },
    },
    {
      id: 'service-green',
      name: 'Service Green',
      isPrimary: false,
      colors: {
        primary: '#27ae60',
        secondary: '#2ecc71',
        accent: '#f39c12',
        background: '#ffffff',
        text: '#333333',
        textMuted: '#666666',
      },
    },
  ],
  'electrician': [
    {
      id: 'electrician-technical',
      name: 'Electrician Technical',
      isPrimary: true,
      colors: {
        primary: '#0066FF',
        secondary: '#FFD700',
        accent: '#00AA00',
        background: '#F1F5F9',
        text: '#0F172A',
        textMuted: '#334155',
      },
    },
    {
      id: 'handyman-blue',
      name: 'Handyman Blue',
      isPrimary: false,
      colors: {
        primary: '#0077b6',
        secondary: '#00b4d8',
        accent: '#ff6b35',
        background: '#ffffff',
        text: '#333333',
        textMuted: '#666666',
      },
    },
  ],
  'plumber': [
    {
      id: 'plumber-water',
      name: 'Plumber Water',
      isPrimary: true,
      colors: {
        primary: '#0077B6',
        secondary: '#00B4D8',
        accent: '#023E8A',
        background: '#CAF0F8',
        text: '#023E8A',
        textMuted: '#0077B6',
      },
    },
    {
      id: 'professional-builder',
      name: 'Professional Builder',
      isPrimary: false,
      colors: {
        primary: '#1E3A5F',
        secondary: '#4A6FA5',
        accent: '#FF6B35',
        background: '#FFFFFF',
        text: '#333333',
        textMuted: '#666666',
      },
    },
  ],
  'hvac-technician': [
    {
      id: 'hvac-temperature',
      name: 'HVAC Temperature',
      isPrimary: true,
      colors: {
        primary: '#00D4FF',
        secondary: '#1E3A5F',
        accent: '#FF6B35',
        background: '#E0F7FA',
        text: '#0D1B2A',
        textMuted: '#0D1B2A',
      },
    },
    {
      id: 'construction-orange',
      name: 'Construction Orange',
      isPrimary: false,
      colors: {
        primary: '#2c3e50',
        secondary: '#e67e22',
        accent: '#f39c12',
        background: '#ffffff',
        text: '#2c3e50',
        textMuted: '#7f8c8d',
      },
    },
  ],
  'carpenter': [
    {
      id: 'carpenter-craftsman',
      name: 'Carpenter Craftsman',
      isPrimary: true,
      colors: {
        primary: '#8B4513',
        secondary: '#D2691E',
        accent: '#5D4037',
        background: '#F4E4BA',
        text: '#1A1A1A',
        textMuted: '#374151',
      },
    },
    {
      id: 'artisan-studio',
      name: 'Artisan Studio',
      isPrimary: false,
      colors: {
        primary: '#2d3436',
        secondary: '#636e72',
        accent: '#fdcb6e',
        background: '#ffffff',
        text: '#2d3436',
        textMuted: '#636e72',
      },
    },
  ],
  'influencer': [
    {
      id: 'instagram-minimal',
      name: 'Instagram Minimal',
      isPrimary: true,
      colors: {
        primary: '#262626',
        secondary: '#8e8e8e',
        accent: '#0095f6',
        background: '#fafafa',
        text: '#262626',
        textMuted: '#8e8e8e',
      },
    },
    {
      id: 'instagram-warm',
      name: 'Warm Tone',
      isPrimary: false,
      colors: {
        primary: '#ed4956',
        secondary: '#fafafa',
        accent: '#ffa852',
        background: '#ffffff',
        text: '#262626',
        textMuted: '#8e8e8e',
      },
    },
    {
      id: 'instagram-dark',
      name: 'Dark Mode',
      isPrimary: false,
      colors: {
        primary: '#fafafa',
        secondary: '#363636',
        accent: '#0095f6',
        background: '#000000',
        text: '#fafafa',
        textMuted: '#a8a8a8',
      },
    },
  ],
  'creator': [
    {
      id: 'creative-warm',
      name: 'Creative Warm',
      isPrimary: true,
      colors: {
        primary: '#1a1a2e',
        secondary: '#f8b739',
        accent: '#e94560',
        background: '#fffcf5',
        text: '#1a1a2e',
        textMuted: '#6c757d',
      },
    },
    {
      id: 'modern-editorial',
      name: 'Modern Editorial',
      isPrimary: false,
      colors: {
        primary: '#2d3436',
        secondary: '#dfe6e9',
        accent: '#0984e3',
        background: '#ffffff',
        text: '#2d3436',
        textMuted: '#636e72',
      },
    },
  ],
}

// Sample color palettes (legacy global palettes - kept for fallback)
export const COLOR_PALETTES: Record<string, ColorPalette> = {
  'serene-spa': {
    id: 'serene-spa',
    name: 'Serene Spa',
    colors: {
      primary: '#9CAF88',
      secondary: '#F5F5DC',
      accent: '#D4AF37',
      background: '#FFFAF0',
      text: '#333333',
      textMuted: '#666666',
    },
  },
  'bold-beauty': {
    id: 'bold-beauty',
    name: 'Bold Beauty',
    colors: {
      primary: '#FF69B4',
      secondary: '#000000',
      accent: '#FFD700',
      background: '#FFFFFF',
      text: '#000000',
      textMuted: '#333333',
    },
  },
  'natural-luxe': {
    id: 'natural-luxe',
    name: 'Natural Luxe',
    colors: {
      primary: '#C67B5C',
      secondary: '#D4B896',
      accent: '#556B2F',
      background: '#FAF0E6',
      text: '#333333',
      textMuted: '#666666',
    },
  },
  'modern-minimal': {
    id: 'modern-minimal',
    name: 'Modern Minimal',
    colors: {
      primary: '#333333',
      secondary: '#FFFFFF',
      accent: '#FFB6C1',
      background: '#FFFFFF',
      text: '#333333',
      textMuted: '#666666',
    },
  },
  'professional-builder': {
    id: 'professional-builder',
    name: 'Professional Builder',
    colors: {
      primary: '#1E3A5F',
      secondary: '#4A6FA5',
      accent: '#FF6B35',
      background: '#FFFFFF',
      text: '#333333',
      textMuted: '#666666',
    },
  },
  'gallery-white': {
    id: 'gallery-white',
    name: 'Gallery White',
    colors: {
      primary: '#000000',
      secondary: '#FFFFFF',
      accent: '#0066CC',
      background: '#FFFFFF',
      text: '#000000',
      textMuted: '#666666',
    },
  },
  // Creative industry palettes
  'creative-portfolio': {
    id: 'creative-portfolio',
    name: 'Creative Portfolio',
    colors: {
      primary: '#1a1a2e',
      secondary: '#16213e',
      accent: '#e94560',
      background: '#fafafa',
      text: '#1a1a2e',
      textMuted: '#6c757d',
    },
  },
  'artisan-studio': {
    id: 'artisan-studio',
    name: 'Artisan Studio',
    colors: {
      primary: '#2d3436',
      secondary: '#636e72',
      accent: '#fdcb6e',
      background: '#ffffff',
      text: '#2d3436',
      textMuted: '#636e72',
    },
  },
  'photo-dark': {
    id: 'photo-dark',
    name: 'Photography Dark',
    colors: {
      primary: '#ffffff',
      secondary: '#2d3436',
      accent: '#00cec9',
      background: '#1a1a1a',
      text: '#ffffff',
      textMuted: '#b2bec3',
    },
  },
  // Trade industry palettes
  'trade-professional': {
    id: 'trade-professional',
    name: 'Trade Professional',
    colors: {
      primary: '#1E3A5F',
      secondary: '#4A6FA5',
      accent: '#FF6B35',
      background: '#F8F9FA',
      text: '#333333',
      textMuted: '#666666',
    },
  },
  'handyman-blue': {
    id: 'handyman-blue',
    name: 'Handyman Blue',
    colors: {
      primary: '#0077b6',
      secondary: '#00b4d8',
      accent: '#ff6b35',
      background: '#ffffff',
      text: '#333333',
      textMuted: '#666666',
    },
  },
  'construction-orange': {
    id: 'construction-orange',
    name: 'Construction Orange',
    colors: {
      primary: '#2c3e50',
      secondary: '#e67e22',
      accent: '#f39c12',
      background: '#ffffff',
      text: '#2c3e50',
      textMuted: '#7f8c8d',
    },
  },
  'service-green': {
    id: 'service-green',
    name: 'Service Green',
    colors: {
      primary: '#27ae60',
      secondary: '#2ecc71',
      accent: '#f39c12',
      background: '#ffffff',
      text: '#333333',
      textMuted: '#666666',
    },
  },
  // NEW: Photographer Luxurious
  'photographer-luxurious': {
    id: 'photographer-luxurious',
    name: 'Photographer Luxurious',
    colors: {
      primary: '#2C2C2C',
      secondary: '#C9A962',
      accent: '#E8D5D0',
      background: '#FAF8F5',
      text: '#2C2C2C',
      textMuted: '#8B7E74',
    },
  },
  // NEW: Beauty Luxurious
  'beauty-luxurious': {
    id: 'beauty-luxurious',
    name: 'Beauty Luxurious',
    colors: {
      primary: '#D4AF37',
      secondary: '#CD7F32',
      accent: '#2D2D2D',
      background: '#FAF7F2',
      text: '#0A0A0A',
      textMuted: '#2D2D2D',
    },
  },
  // NEW: Event Planner Elegant
  'event-planner-elegant': {
    id: 'event-planner-elegant',
    name: 'Event Planner Elegant',
    colors: {
      primary: '#1A1A1A',
      secondary: '#F7E7CE',
      accent: '#D4AF37',
      background: '#FFFFF0',
      text: '#1A1A1A',
      textMuted: '#E8B4B8',
    },
  },
  // NEW: Tattoo Edgy
  'tattoo-edgy': {
    id: 'tattoo-edgy',
    name: 'Tattoo Edgy',
    colors: {
      primary: '#1A1A1A',
      secondary: '#FF00FF',
      accent: '#00FFFF',
      background: '#1A1A1A',
      text: '#F5F0E8',
      textMuted: '#C0C0C0',
    },
  },
  // NEW: Artist Contemporary
  'artist-contemporary': {
    id: 'artist-contemporary',
    name: 'Artist Contemporary',
    colors: {
      primary: '#0F0F0F',
      secondary: '#FF6B6B',
      accent: '#4ECDC4',
      background: '#F5F5F0',
      text: '#333333',
      textMuted: '#333333',
    },
  },
  // NEW: Florist Natural
  'florist-natural': {
    id: 'florist-natural',
    name: 'Florist Natural',
    colors: {
      primary: '#2D4A3E',
      secondary: '#9CAF88',
      accent: '#D4A5A5',
      background: '#FDF8F5',
      text: '#2D4A3E',
      textMuted: '#9CAF88',
    },
  },
  // NEW: Esthetician Spa
  'esthetician-spa': {
    id: 'esthetician-spa',
    name: 'Esthetician Spa',
    colors: {
      primary: '#F43F5E',
      secondary: '#FDA4AF',
      accent: '#6B7280',
      background: '#FFF1F2',
      text: '#1F2937',
      textMuted: '#6B7280',
    },
  },
  // NEW: Nail Technician Feminine
  'nail-feminine': {
    id: 'nail-feminine',
    name: 'Nail Technician Feminine',
    colors: {
      primary: '#DB2777',
      secondary: '#F472B6',
      accent: '#059669',
      background: '#FDF2F8',
      text: '#831843',
      textMuted: '#9D174D',
    },
  },
  // NEW: Tutor Academic
  'tutor-academic': {
    id: 'tutor-academic',
    name: 'Tutor Academic',
    colors: {
      primary: '#1A365D',
      secondary: '#2C5282',
      accent: '#D69E2E',
      background: '#EBF8FF',
      text: '#4A5568',
      textMuted: '#4A5568',
    },
  },
  // NEW: Hair Stylist Editorial
  'hair-editorial': {
    id: 'hair-editorial',
    name: 'Hair Stylist Editorial',
    colors: {
      primary: '#1C1917',
      secondary: '#78716C',
      accent: '#D97706',
      background: '#FAFAF9',
      text: '#1C1917',
      textMuted: '#44403C',
    },
  },
  // NEW: Personal Trainer Energetic
  'trainer-energetic': {
    id: 'trainer-energetic',
    name: 'Personal Trainer Energetic',
    colors: {
      primary: '#FF4500',
      secondary: '#FF6B35',
      accent: '#1E1E1E',
      background: '#DFE6E9',
      text: '#2D3436',
      textMuted: '#2D3436',
    },
  },
  // NEW: Electrician Technical
  'electrician-technical': {
    id: 'electrician-technical',
    name: 'Electrician Technical',
    colors: {
      primary: '#0066FF',
      secondary: '#FFD700',
      accent: '#00AA00',
      background: '#F1F5F9',
      text: '#0F172A',
      textMuted: '#334155',
    },
  },
  // NEW: Plumber Water
  'plumber-water': {
    id: 'plumber-water',
    name: 'Plumber Water',
    colors: {
      primary: '#0077B6',
      secondary: '#00B4D8',
      accent: '#023E8A',
      background: '#CAF0F8',
      text: '#023E8A',
      textMuted: '#0077B6',
    },
  },
  // NEW: HVAC Temperature
  'hvac-temperature': {
    id: 'hvac-temperature',
    name: 'HVAC Temperature',
    colors: {
      primary: '#00D4FF',
      secondary: '#1E3A5F',
      accent: '#FF6B35',
      background: '#E0F7FA',
      text: '#0D1B2A',
      textMuted: '#0D1B2A',
    },
  },
  // NEW: Carpenter Craftsman
  'carpenter-craftsman': {
    id: 'carpenter-craftsman',
    name: 'Carpenter Craftsman',
    colors: {
      primary: '#8B4513',
      secondary: '#D2691E',
      accent: '#5D4037',
      background: '#F4E4BA',
      text: '#1A1A1A',
      textMuted: '#374151',
    },
  },
}

// Template configurations
export const TEMPLATES: Template[] = [
  {
    id: 1,
    name: 'Beauty & Wellness',
    slug: 'beauty',
    industry: 'beauty',
    description: 'Elegant template for beauty professionals, salons, and wellness practitioners',
    palettes: TEMPLATE_PALETTES['beauty'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito', 'montserrat-open-sans', 'fraunces-work-sans'],
  },
  {
    id: 2,
    name: 'Creative Portfolio',
    slug: 'creative',
    industry: 'creative',
    description: 'Showcase your creative work with this gallery-focused template',
    palettes: TEMPLATE_PALETTES['creative'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito', 'montserrat-open-sans', 'fraunces-work-sans'],
  },
  {
    id: 3,
    name: 'Trade & Services',
    slug: 'trade',
    industry: 'trade',
    description: 'Professional template for tradespeople and service providers',
    palettes: TEMPLATE_PALETTES['trade'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito', 'montserrat-open-sans', 'fraunces-work-sans'],
  },
  // ARTISTIC templates
  {
    id: 4,
    name: 'Photographer',
    slug: 'photographer',
    industry: 'artistic',
    description: 'Professional template for photographers showcasing their portfolio',
    palettes: TEMPLATE_PALETTES['photographer'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito', 'montserrat-open-sans', 'fraunces-work-sans'],
  },
  {
    id: 5,
    name: 'Tattoo Artist',
    slug: 'tattoo-artist',
    industry: 'artistic',
    description: 'Bold creative template for tattoo artists and body artists',
    palettes: TEMPLATE_PALETTES['tattoo-artist'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito', 'montserrat-open-sans', 'fraunces-work-sans'],
  },
  {
    id: 6,
    name: 'Florist',
    slug: 'florist',
    industry: 'artistic',
    description: 'Elegant template for florists and floral designers',
    palettes: TEMPLATE_PALETTES['florist'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito', 'montserrat-open-sans', 'fraunces-work-sans'],
  },
  {
    id: 7,
    name: 'Artist Painter',
    slug: 'artist-painter',
    industry: 'artistic',
    description: 'Gallery-style template for fine artists and painters',
    palettes: TEMPLATE_PALETTES['artist-painter'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito', 'montserrat-open-sans', 'fraunces-work-sans'],
  },
  // BEAUTY templates
  {
    id: 8,
    name: 'Makeup Artist',
    slug: 'makeup-artist',
    industry: 'beauty',
    description: 'Glamorous template for makeup artists and beauty professionals',
    palettes: TEMPLATE_PALETTES['makeup-artist'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito', 'montserrat-open-sans', 'fraunces-work-sans'],
  },
  {
    id: 9,
    name: 'Nail Technician',
    slug: 'nail-technician',
    industry: 'beauty',
    description: 'Stylish template for nail technicians and manicure specialists',
    palettes: TEMPLATE_PALETTES['nail-technician'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito', 'montserrat-open-sans', 'fraunces-work-sans'],
  },
  {
    id: 10,
    name: 'Hair Stylist',
    slug: 'hair-stylist',
    industry: 'beauty',
    description: 'Modern template for hair stylists and salon professionals',
    palettes: TEMPLATE_PALETTES['hair-stylist'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito', 'montserrat-open-sans', 'fraunces-work-sans'],
  },
  {
    id: 11,
    name: 'Esthetician',
    slug: 'esthetician',
    industry: 'beauty',
    description: 'Relaxing spa-like template for estheticians and skin care professionals',
    palettes: TEMPLATE_PALETTES['esthetician'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito', 'montserrat-open-sans', 'fraunces-work-sans'],
  },
  // SERVICES templates
  {
    id: 12,
    name: 'Event Planner',
    slug: 'event-planner',
    industry: 'services',
    description: 'Elegant template for event planners and party coordinators',
    palettes: TEMPLATE_PALETTES['event-planner'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito', 'montserrat-open-sans', 'fraunces-work-sans'],
  },
  {
    id: 13,
    name: 'Tutor Teacher',
    slug: 'tutor-teacher',
    industry: 'services',
    description: 'Professional template for tutors, teachers, and educators',
    palettes: TEMPLATE_PALETTES['tutor-teacher'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito', 'montserrat-open-sans', 'fraunces-work-sans'],
  },
  {
    id: 14,
    name: 'Personal Trainer',
    slug: 'personal-trainer',
    industry: 'services',
    description: 'Energetic template for personal trainers and fitness coaches',
    palettes: TEMPLATE_PALETTES['personal-trainer'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito', 'montserrat-open-sans', 'fraunces-work-sans'],
  },
  // TRADE templates
  {
    id: 15,
    name: 'Electrician',
    slug: 'electrician',
    industry: 'trade',
    description: 'Professional template for electricians and electrical contractors',
    palettes: TEMPLATE_PALETTES['electrician'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito', 'montserrat-open-sans', 'fraunces-work-sans'],
  },
  {
    id: 16,
    name: 'Plumber',
    slug: 'plumber',
    industry: 'trade',
    description: 'Reliable template for plumbers and plumbing services',
    palettes: TEMPLATE_PALETTES['plumber'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito', 'montserrat-open-sans', 'fraunces-work-sans'],
  },
  {
    id: 17,
    name: 'HVAC Technician',
    slug: 'hvac-technician',
    industry: 'trade',
    description: 'Technical template for HVAC technicians and climate control specialists',
    palettes: TEMPLATE_PALETTES['hvac-technician'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito', 'montserrat-open-sans', 'fraunces-work-sans'],
  },
  {
    id: 18,
    name: 'Carpenter',
    slug: 'carpenter',
    industry: 'trade',
    description: 'Craftsman template for carpenters and woodworking professionals',
    palettes: TEMPLATE_PALETTES['carpenter'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito', 'montserrat-open-sans', 'fraunces-work-sans'],
  },
  // SOCIAL templates
  {
    id: 19,
    name: 'Influencer',
    slug: 'influencer',
    industry: 'social',
    description: 'Instagram-style template for influencers and content creators',
    palettes: TEMPLATE_PALETTES['influencer'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito'],
  },
  {
    id: 20,
    name: 'Social Creator',
    slug: 'social-creator',
    industry: 'social',
    description: 'Modern social media profile for creators and artists',
    palettes: TEMPLATE_PALETTES['creator'] || [],
    typographyPairs: ['playfair-dm-sans', 'cormorant-nunito'],
  },
]

export function getTemplateBySlug(slug: string): Template | undefined {
  return TEMPLATES.find((t) => t.slug === slug)
}

// Sample typography options
export const TYPOGRAPHY_OPTIONS: Record<string, Typography> = {
  'playfair-dm-sans': {
    id: 'playfair-dm-sans',
    name: 'Playfair + DM Sans',
    heading: 'Playfair Display, serif',
    body: 'DM Sans, sans-serif',
  },
  'cormorant-nunito': {
    id: 'cormorant-nunito',
    name: 'Cormorant + Nunito',
    heading: 'Cormorant, serif',
    body: 'Nunito, sans-serif',
  },
  'montserrat-open-sans': {
    id: 'montserrat-open-sans',
    name: 'Montserrat + Open Sans',
    heading: 'Montserrat, sans-serif',
    body: 'Open Sans, sans-serif',
  },
  'fraunces-work-sans': {
    id: 'fraunces-work-sans',
    name: 'Fraunces + Work Sans',
    heading: 'Fraunces, serif',
    body: 'Work Sans, sans-serif',
  },
  'bebas-nunito': {
    id: 'bebas-nunito',
    name: 'Bebas Neue + Nunito',
    heading: 'Bebas Neue, cursive',
    body: 'Nunito, sans-serif',
  },
  'oswald-lato': {
    id: 'oswald-lato',
    name: 'Oswald + Lato',
    heading: 'Oswald, sans-serif',
    body: 'Lato, sans-serif',
  },
  'poppins-lato': {
    id: 'poppins-lato',
    name: 'Poppins + Lato',
    heading: 'Poppins, sans-serif',
    body: 'Lato, sans-serif',
  },
  'raleway-montserrat': {
    id: 'raleway-montserrat',
    name: 'Raleway + Montserrat',
    heading: 'Raleway, sans-serif',
    body: 'Montserrat, sans-serif',
  },
}

// Get template colors by template slug and optional palette id
export function getTemplateColors(templateSlug: string, paletteId?: string): ColorPalette {
  // First check if templateSlug is actually a palette ID in global COLOR_PALETTES
  if (COLOR_PALETTES[templateSlug]) {
    return COLOR_PALETTES[templateSlug]
  }
  
  // Then check TEMPLATE_PALETTES
  const palettes = TEMPLATE_PALETTES[templateSlug]
  if (!palettes || palettes.length === 0) {
    return COLOR_PALETTES['modern-minimal']
  }
  
  const palette = paletteId 
    ? palettes.find(p => p.id === paletteId)
    : palettes.find(p => p.isPrimary) || palettes[0]
    
  return palette ? { id: palette.id, name: palette.name, colors: palette.colors } : COLOR_PALETTES['modern-minimal']
}

// Get palette by template slug and palette id
export function getPaletteById(templateSlug: string, paletteId: string): TemplatePalette | undefined {
  const palettes = TEMPLATE_PALETTES[templateSlug]
  return palettes?.find(p => p.id === paletteId)
}

// Get primary palette for a template
export function getPrimaryPalette(templateSlug: string): TemplatePalette | undefined {
  const palettes = TEMPLATE_PALETTES[templateSlug]
  return palettes?.find(p => p.isPrimary) || palettes?.[0]
}

export function getTemplateTypography(typographyId: string): Typography {
  return TYPOGRAPHY_OPTIONS[typographyId] || TYPOGRAPHY_OPTIONS['playfair-dm-sans']
}
